import { useWishlist } from '../../context/WishlistContext';
import { useAuth } from '../../context/AuthContext';
import { useSite } from '../../context/SiteContext';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, User, MapPin, ShoppingBag, Menu, X, ChevronDown, Heart } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { navCategories } from '../../data/products';
import BrandLogo from '../BrandLogo/BrandLogo';
import './Header.css';

const Header = () => {
  const { siteName } = useSite();
  const [searchQuery, setSearchQuery] = useState('');
  const { isAuthenticated, signOut } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { getTotalItems, openCart } = useCart();
  const totalItems = getTotalItems();
  const { getWishlistCount } = useWishlist();
  const wishlistCount = getWishlistCount();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.location.href = `/shop?search=${encodeURIComponent(searchQuery)}`;
    }
  };

  return (
    <header className="header">
      <div className="header-top">
        Free shipping $75+ · Fresh deals daily · <Link to="/sale">Shop sale</Link> · <Link to="/rewards">Join Deals List</Link>
      </div>

      <div className="header-main">
        <button
          className="header-mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Menu"
        >
          {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>

        <Link to="/" className="header-logo" aria-label={siteName}>
          <BrandLogo size={34} />
        </Link>

        <div className="header-search">
          <form onSubmit={handleSearch}>
            <Search className="header-search-icon" />
            <input
              type="text"
              placeholder="Search styles, home, beauty…"
              className="header-search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </form>
        </div>

        <div className="header-actions">
          <Link to="/stores" className="header-action-btn">
            <MapPin className="header-action-icon" />
            <span className="header-action-text">Stores</span>
          </Link>

          <Link to="/wishlist" className="header-action-btn header-wishlist-btn">
            <Heart className="header-action-icon" />
            {wishlistCount > 0 && <span className="header-wishlist-count">{wishlistCount}</span>}
            <span className="header-action-text">Saved</span>
          </Link>

          {isAuthenticated ? (
            <button type="button" onClick={signOut} className="header-action-btn">
              <User className="header-action-icon" />
              <span className="header-action-text">Sign Out</span>
            </button>
          ) : (
            <Link to="/signin" className="header-action-btn">
              <User className="header-action-icon" />
              <span className="header-action-text">Sign In</span>
            </Link>
          )}

          <button type="button" onClick={openCart} className="header-action-btn header-cart-btn">
            <ShoppingBag className="header-action-icon" />
            {totalItems > 0 && <span className="header-cart-count">{totalItems}</span>}
            <span className="header-action-text">Bag</span>
          </button>
        </div>
      </div>

      <nav className={`header-nav ${isMobileMenuOpen ? 'header-nav--open' : ''}`}>
        <div className="header-nav-container">
          <ul className="header-nav-list">
            {navCategories.map((category) => (
              <li key={category.id} className="header-nav-item">
                <Link
                  to={`/category/${category.id}`}
                  className="header-nav-link"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {category.name}
                  <ChevronDown size={14} />
                </Link>
                <div className="header-nav-dropdown">
                  <ul className="header-nav-dropdown-list">
                    {category.subcategories.map((sub) => (
                      <li key={sub}>
                        <Link
                          to={`/category/${category.id}/${sub.toLowerCase().replace(/\s+/g, '-')}`}
                          className="header-nav-dropdown-item"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          {sub}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            ))}
            <li className="header-nav-item">
              <Link to="/sale" className="header-nav-link sale" onClick={() => setIsMobileMenuOpen(false)}>
                Clearance
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
